import { useState, useEffect } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import ChatScroll from './Components/ChatScroll/ChatScroll';
import { configureStore } from './store/configureStore';
import Login from './Login/Login';

const SECRET_PASSWORD = process.env.REACT_APP_INTERNAL_DEV_PASSWORD;
const PASSWORD_HASH = btoa(SECRET_PASSWORD); // Base64 encoding

const configFileName = process.env.REACT_APP_CONFIG_FILE;
const IS_INTERNAL_DEV = configFileName === 'config.ema-internal-dev.js';

const App = () => {
  const store = configureStore();

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (IS_INTERNAL_DEV) {
      const auth = localStorage.getItem('auth');
      if (auth === PASSWORD_HASH) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('auth'); // Clear auth on logout
    setIsAuthenticated(false);
  };

  return (
    <div>
      {IS_INTERNAL_DEV && !isAuthenticated ? (
        <Login setIsAuthenticated={setIsAuthenticated} />
      ) : (
        <Provider store={store}>
          <div className="App">
            <ChatScroll />
          </div>
        </Provider>
      )}
    </div>
  );
};

export default App;
